__turbopack_context__.v({
  "app_light_theme": "OpenRegionNavButton-module-scss-module__U_blqq__app_light_theme",
  "button": "OpenRegionNavButton-module-scss-module__U_blqq__button",
});
